module.exports = __webpack_public_path__ + "img/SELO-FURTADO.55e818f2.png";